import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { RoomEditContainer } from "@/components/features/items/edit/room/standard/default/ui/existing";

import { useGetRoomEditPageParams } from "./_hooks/use-get-room-edit-page-params";

export const RoomEditPageDefault = () => {
	const { hotelID, roomID } = useGetRoomEditPageParams();
	const activeLangCode = LangCode.Default;
	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, { hotelID, roomID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.I18N, { hotelID, roomID, langCode }),
	};

	return (
		<PageMeta
			title="部屋の編集"
			url={generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, { hotelID, roomID })}
		>
			<RoomEditContainer
				hotelID={hotelID}
				roomID={roomID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

RoomEditPageDefault.displayName = "RoomEditPageDefault";
